<fui-edit-fascia [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [valued]="valued"></fui-input-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        @if (icon) {
            <fui-fixture>
                <ng-content select="fui-icon"></ng-content>
            </fui-fixture>
        }
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)"
                       (keypress)="keypress($event)"
                       [(ngModel)]="query" [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text">
            </fui-input-dom>
        </fui-spanning-fixture>
        @if (validateable) {
            <fui-fixture>
                <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
            </fui-fixture>
        }
    </fui-fixtures>
</fui-edit-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop()">
    <fui-sections>
        @if (loading) {
            <fui-content-section>
                <fui-loading>
                    <fui-ellipsis-loader></fui-ellipsis-loader>
                </fui-loading>
            </fui-content-section>
        }
        @if (empty(options)) {
            <fui-content-section>
                <fui-empty>
                    <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
                </fui-empty>
            </fui-content-section>
        }
        @if (filled(options)) {
            <fui-section>
                <fui-autocomplete-options [field]="field" [key]="key" [options]="options"
                                          (selection$)="select($event)"></fui-autocomplete-options>
            </fui-section>
        }
    </fui-sections>
</fui-select-pop>
